import { TournamentAnalysisQuickStatsCard } from "./TournamentAnalysisQuickStatsCard";
import { TournamentAnalysisRecentGamesCard } from "./TournamentAnalysisRecentGamesCard";
import { TournamentAnalysisTopPerformersCard } from "./TournamentAnalysisTopPerformersCard";
import { type TopPlayer, type TeamAnalysisMatches, type TeamStats } from "@/api/tournamentAnalysis";
import { type QuickStats } from "@/api/quickStats";

interface TournamentsAnalysisCardsProps {
    tournamentId?: number;
    topPlayers?: TopPlayer[];
    topPlayersLoading?: boolean;
    matchesData?: TeamAnalysisMatches;
    matchesLoading?: boolean;
    teamStats?: TeamStats;
    teamStatsLoading?: boolean;
    quickStatsData?: QuickStats;
    quickStatsLoading?: boolean;
}

export function TournamentsAnalysisCards({
    tournamentId,
    topPlayers,
    topPlayersLoading,
    matchesData,
    matchesLoading,
    teamStats,
    teamStatsLoading,
    quickStatsData,
    quickStatsLoading,
}: TournamentsAnalysisCardsProps) {
    return (
        <div className="w-full grid grid-cols-1 xl:grid-cols-3 gap-4 items-stretch">
            <div className="flex flex-col gap-1">
                <h3 className="px-4 pt-3 pb-1 text-sm font-headline font-bold section-title">Top Performers</h3>
                <TournamentAnalysisTopPerformersCard topPlayers={topPlayers} isLoading={topPlayersLoading} />
            </div>
            <div className="flex flex-col gap-1">
                <h3 className="px-4 pt-3 pb-1 text-sm font-headline font-bold section-title">Recent Games</h3>
                <TournamentAnalysisRecentGamesCard data={matchesData} isLoading={matchesLoading} />
            </div>
            <div className="flex flex-col gap-1">
                <h3 className="px-4 pt-3 pb-1 text-sm font-headline font-bold section-title">Quick Stats</h3>
                <TournamentAnalysisQuickStatsCard
                    teamStats={teamStats}
                    isLoading={teamStatsLoading}
                    tournamentId={tournamentId}
                    quickStatsData={quickStatsData}
                    quickStatsLoading={quickStatsLoading}
                />
            </div>
        </div>
    );
}
